// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewBanner_root__lr9af","paragraph":"PreviewBanner_paragraph__jNJQP"};